// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.m-topbar .m-topbar__nav .language-options.ui-dropdown .dropdown-menu {\n  min-width: 7.65rem;\n}\n.m-topbar .m-topbar__nav .language-options.ui-dropdown ul li a.dropdown-item {\n  padding: 0.2rem 1rem;\n  font-size: 0.875rem;\n}\n", ""]);
// Exports
module.exports = exports;
